export default "__VITE_ASSET__b54d4d22__"